module.exports = __webpack_public_path__ + "static/media/Clock.7b1f6e6a.svg";